import { render } from "./MiniBI.vue?vue&type=template&id=8b5fea92"
import script from "./MiniBI.vue?vue&type=script&lang=js"
export * from "./MiniBI.vue?vue&type=script&lang=js"

import "./MiniBI.vue?vue&type=style&index=0&id=8b5fea92&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__